/**
 * Created by Kamil.Adamuszek on 2016-05-25.
 */
'use strict';
import { __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import labelTemplate from '../template/label.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
var labelTemplates = {
    defaultTemplate: labelTemplate,
};
/**
 * BSSLabelComponent class
 */
var BSSLabelComponent = /** @class */ (function (_super) {
    __extends(BSSLabelComponent, _super);
    /**
     * @desc BSSLabelComponent constructor - generates all necessary objects and initialize slider
     * @param {object} entityTemplate simulator template
     * @param {string} containerSelector container selector of components
     * @param {object} config configuration object
     * @param {eventManager} eventManager instance of _eventManager
     * @param {Formatter} Formatter instance of Formatter
     * @param {Resolution} Resolution device resolution
     * @param {object} toolbox - provides common libraries: jquery and lodash
     */
    function BSSLabelComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, labelTemplates, toolbox) || this;
        _this._componentVersion = '@@name ver. @@version';
        if ((_this._config.value === undefined || _this._config.value === '') &&
            (_this._config.text === undefined || _this._config.text === '')) {
            logger.warn('Component ' +
                _this._config.componentId +
                " don't have:  text && value ");
            _this._toolbox.$('#' + _this._config.componentId).css('display', 'none');
        }
        else {
            logger.info('Component ' +
                _this._config.componentId +
                ' has been successful render');
        }
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        return _this;
    }
    /**
     *
     * @public method
     * @desc destroys infohint and call super method
     */
    BSSLabelComponent.prototype.destroy = function () {
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    return BSSLabelComponent;
}(BSSAbstractComponent));
export default BSSLabelComponent;
